module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery3_m.0f2e6bc3a7a93fcfa5393477b2cc3e3f.png";